/**
 * Google Fonts available for the Text Logo (Main logo and Second line).
 * Matches the list from HM Pro Experience Figma (Logo editor / Google Fonts).
 */
export const LOGO_GOOGLE_FONTS = [
  "Alex Brush",
  "Bebas Neue",
  "Birthstone",
  "Borel",
  "Corinthia",
  "DM Serif Text",
  "Fredoka",
  "Inter",
  "Lora",
  "Merriweather",
  "Montserrat",
  "Mr Dafoe",
  "Niconne",
  "Nunito",
  "Oleo Script",
  "Oswald",
  "Pacifico",
  "Pattaya",
  "Paytone One",
  "Pecita",
  "Playball",
  "Playfair Display",
  "Platypi",
  "Poppins",
  "Raleway",
  "Roboto",
  "Sarina",
  "Ubuntu",
  "Yellowtail"
] as const

export type LogoFontName = (typeof LOGO_GOOGLE_FONTS)[number]

/** Default font when none selected (Inter is widely used and readable). */
export const DEFAULT_LOGO_FONT: LogoFontName = "Inter"

/**
 * Build Google Fonts CSS2 URL for logo font list (single weight 400 for dropdown preview).
 */
export function getLogoFontsStylesheetUrl(): string {
  const families = LOGO_GOOGLE_FONTS.map(
    (name) => `family=${name.replace(/\s+/g, "+")}:wght@400`
  ).join("&")
  return `https://fonts.googleapis.com/css2?${families}&display=swap`
}
